import {
  IServiceUrls,
  IAppConfig,
  IAppConfigPerEnvironment,
  GENERAL_APP_CONFIG,
} from "./AppConfigModels";

const getServiceUrls = (apiEndpoint: string, aiAgentEndpoint: string): IServiceUrls => {
  const backendUrl = `${apiEndpoint}/backend`;
  return {
    apiHostUrl: apiEndpoint,
    aiAgentHostUrl: aiAgentEndpoint,
    siteAppsConfigUrlPrefix: `${backendUrl}/site-apps-config-service`,
    userRecordsUrlPrefix: `${backendUrl}/user-records`,
    siteGatewayUrlPrefix: `${backendUrl}/site-gateway`,
    historianTagsSystemBaseUrl: `${backendUrl}/historian-ts-api`,
    dualUsageUrlPrefix: `${backendUrl}/pvdualusage`,
  };
};

const getDevConfig = (): IAppConfigPerEnvironment => ({
  mixpanelProjectId: "002151a9f8712f0b6486b5e83d0e5c62",
  serviceUrls: getServiceUrls("/api", "/sunnie"),
  authConfig: {
    tenantName: "B2CDevPortal",
    clientId: "eabccd2c-fcf6-4667-9def-a71ba6b59e2d",
    authorityDomain: "B2CDevPortal.b2clogin.com",
    webApiScope:
      "https://B2CDevPortal.onmicrosoft.com/ccbe149e-7155-4dfb-b5c0-71710fe91817/access_as_user",
    signInAuth: "https://B2CDevPortal.b2clogin.com/B2CDevPortal.onmicrosoft.com/B2C_1_si",
  },
});

const getProdConfig = (): IAppConfigPerEnvironment => ({
  mixpanelProjectId: "66e609662ab5764dbb4e35208b4e4b06",
  serviceUrls: getServiceUrls("/api", "/sunnie"),
  authConfig: {
    tenantName: "SolargikPortalB2c",
    clientId: "33f6c390-284d-4764-b56f-295934128d07",
    authorityDomain: "SolargikPortalB2c.b2clogin.com",
    webApiScope:
      "https://SolargikPortalB2c.onmicrosoft.com/d6a06e43-2ba8-4612-bc7e-8377c5a7c054/access_as_user",
    signInAuth: "https://SolargikPortalB2c.b2clogin.com/SolargikPortalB2c.onmicrosoft.com/B2C_1_psi", // need to configure
  },
});

const getAspireLocalConfig = (): IAppConfig => {
  const backendEndpoint = import.meta.env.VITE_SOMA_BACKEND_ENDPOINT?.replace(/\/$/, "");
  if (!backendEndpoint) {
    throw new Error("VITE_SOMA_BACKEND_ENDPOINT is required when VITE_SOMA_LOCAL is enabled.");
  }

  return {
    ...GENERAL_APP_CONFIG,
    ...getDevConfig(),
    serviceUrls: getServiceUrls(`${backendEndpoint}/api`, `${backendEndpoint}/sunnie`),
    mixpanelProjectId: undefined,
  };
};

const APP_CONFIG: IAppConfig = (function (): IAppConfig {
  if (import.meta.env.VITE_SOMA_LOCAL === "true") {
    return getAspireLocalConfig();
  }

  switch (window.location.host) {
    case "portal.solargik.com":
      return { ...GENERAL_APP_CONFIG, ...getProdConfig() };
    case "portal.green.solargik.com":
      return {
        ...GENERAL_APP_CONFIG,
        ...getProdConfig(),
        mixpanelProjectId: "6ef2ef86b5a96f6d6ad176b4f3471545",
      };
    case "portal.dev.solargik.com":
      return { ...GENERAL_APP_CONFIG, ...getDevConfig() };
  }

  if (window.location.hostname === "localhost") {
    return {
      ...GENERAL_APP_CONFIG,
      ...getDevConfig(),
      serviceUrls: getServiceUrls("http://localhost:7000/api", "http://localhost:8080/sunnie"),
      mixpanelProjectId: undefined,
    };
  }

  throw new Error(`Couldn't figure out correct environment from host URL (${window.location.host})`);
})();

export default APP_CONFIG;
